var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "22", height: "22", viewBox: "0 0 22 22", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.55.25c3.98 0 5.19 1.21 5.19 5.19v6.443a.736.736 0 0 1-.002.247c-.065 3.703-1.32 4.84-5.178 4.84l-4.81-.001v3.281h3.75c.41 0 .75.34.75.75s-.34.75-.75.75h-9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.75v-3.281l-4.81.001c-3.9 0-5.14-1.162-5.189-4.953A.066.066 0 0 1 .25 12l.001-.015v-.102L.25 5.44C.25 1.46 1.46.25 5.44.25h11.11zm3.665 12.5H1.775c.132 2.219.846 2.686 3.45 2.71H16.55c2.78 0 3.53-.431 3.665-2.71zm-3.45-11H5.44c-3.067 0-3.663.525-3.69 3.475v6.025h18.489V5.225c-.025-2.88-.594-3.449-3.474-3.474z", fill: "#292D32", fillRule: "evenodd" })
  );
});